import axios from 'axios';
import store from '../store';
import { ApiMigrationService } from './ApiMigrationService';

export class StaticDataService {

  static async init() {
    try {
      const originalUrl = '/api/v1/staticdata?ids=100205&ids=100120';
      const { resolvedUrl, transformResponse } = ApiMigrationService.getRoutedApi(originalUrl, null);
      const response = await axios.get(resolvedUrl);
      let apiResponse = response.data;
      // Apply V3 to V1 transformation
      if (transformResponse) {
        apiResponse = transformResponse(apiResponse);
      }
      store.commit('setStaticData', StaticDataService.convertArrayToObject(apiResponse));
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: 'error in static Data', show: true, color: 'error' })
    }
  }

  static convertArrayToObject(apiResponse: any) {
    const staticData: any = {};
    apiResponse.data.map((staticDataSet: any) => {
      staticData[staticDataSet.type] = staticDataSet.data;
    })
    return staticData;
  }
}